<template>

  <mobile-float-menu header>
    <template v-slot:content>
      <div class="container">
        <LanguageLoader routeLanguage="./translations/faqs/faqs_" />
      </div>
    </template>
  </mobile-float-menu>

</template>

<script>
  import MobileFloatMenu from "@/components/MobileFloatMenu";
  import LanguageLoader from '@/components/TranslationsLoader.vue'
  export default {
    components: {
      LanguageLoader,
      MobileFloatMenu,
    },
    methods: {},
    mounted() {}
  }
</script>

<style>
</style>